import React, { useState } from 'react';
import { useVerifyCodeMutation } from '../../redux/slices/emailApiSlice';
import styles from './VerificationForm.module.css';
import { toast } from 'react-toastify';
import Logo from '../../assets/svgs/tevhidlogo.svg';

const VerificationForm = ({ email, onNext }) => {
  const [code, setCode] = useState('');
  const [verifyCode, { isLoading }] = useVerifyCodeMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await verifyCode({ email, code }).unwrap();
      toast.success('Doğrulama başarılı.');
      onNext();
    } catch (error) {
      toast.error('Doğrulama kodu yanlış.');
    }
  };

  return (
    <section className={styles.container}>
      <div className={styles.foregroundImage}>
        <div className={styles.auth}>
          <img src={Logo} alt="Logo" />
          <h1>Kodu Doğrula</h1>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="code"
              placeholder="Doğrulama Kodu"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
            />
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Doğrulanıyor...' : 'Doğrula'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default VerificationForm;